import { SET_CURRENT_FACCAO } from '../actions/actionTypes';

const initialState = {};

export const dataFaccaoReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_FACCAO:
            return {
                ...action.faccao,
            };
        default:
            return state;
    }
};
